import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    checkboxLabel: {
        color: theme.palette.info.main,
        "&.MuiFormControlLabel-root ": {
            margin: 0,
        },
        "& .MuiCheckbox-root": {
            padding: 0,
            marginRight: theme.spacing(1),
        },
        "&  .MuiFormControlLabel-label": {
            fontSize: "9px !important",
            fontFamily: "Source Sans 3",
            textTransform: "uppercase",
            fontWeight: 700,
        },
    },
}));
